module.exports = __webpack_public_path__ + "static/media/MY-MONASH.a76afc5e.png";